import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";

const pointPropertyValue = new AthubRestResource({server: DCIM_SERVER, resource: 'point-property-value'});

export default pointPropertyValue;
